import config from "../../config"
import RequestService from "../RequestService"

const fetchTicket = (id, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/tickets/${id}`, successCallback, failureCallback)
}

export default fetchTicket;